import dayjs from "dayjs";
import { Tournament } from "../types/tournament";

export const sortByStartDate = (tournaments: Array<Tournament>) => {
    return tournaments?.sort(
        (a, b) => dayjs(a.startDate).valueOf() - dayjs(b.startDate).valueOf()
    );
};

export const getActualTournament = (tournaments: Array<Tournament>) => {
    return sortByStartDate(
        tournaments?.filter((t: Tournament) => dayjs(t?.endDate).isAfter(dayjs()))
    );
};

export const sortTournamentsActualFirst = (tournaments: Array<Tournament>) => {
    const futureTournaments = sortByStartDate(
        tournaments?.filter((t: Tournament) => dayjs(t?.startDate).isAfter(dayjs()))
    );

    const restOfTournaments = sortByStartDate(
        tournaments?.filter(
            (t: Tournament) =>
                dayjs(t?.startDate).isBefore(dayjs()) ||
                dayjs(t?.startDate).isSame(dayjs())
        )
    );

    return futureTournaments?.concat(restOfTournaments);
};

export const isNowPlayingTournament = (
    startDate: string | undefined,
    endDate: string | undefined
) => {
    return (
        dayjs(endDate).isAfter(new Date()) &&
        (dayjs(startDate).isSame(new Date()) ||
            dayjs(startDate).isBefore(new Date()))
    );
};
